<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
import Vue from "vue";
import Info from "./info.vue";
import Check from "./check.vue";
// import Track from './track.vue'
export default {
  extends: baseList,
  components: {
    info: Info,
    // Repair,
    // Track,
    Check,
  },
  data() {
    return {
      table: {
        mname: "patrol",
        key: "id",
        url: {
          list:"/maintainer/maintainer/patrol/list",
        },
        output: false,
        order: "createTime",
      },
      actions: [
        // {
        //   label: "新增",
        //   icon: "md-add",
        //   onClick: this.toAdd,
        //   type: "info",
        //   auth: "system/inspection/add",
        // },
      ],
      menus: [
      ],
      filters: [
        {
          label: "巡检名称",
          KeyEnter: this.search,
          name: "patrolName",
          value: "",
          type: "input",
        },
      ],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "巡检名称",
          key: "patrolName",
          minWidth: 120,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.patrolName;
            return (
              <span
                style={{
                  color: row.state == 1 ? "red" : "",
                }}
              >
                {text}
              </span>
            );
          },
        },
        {
          title: "负责人",
          key: "name",
          minWidth: 120,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.name;
            return (
              <span
                style={{
                  color: row.state == 1 ? "red" : "",
                }}
              >
                {text}
              </span>
            );
          },
        },
        {
          title: "巡检类别",
          key: "patrolDimension",
          minWidth: 120,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.patrolDimension == 1
                ? "资产"
                : row.patrolDimension == 2
                ? "场景"
                : "";
            return (
              <span
                style={{
                  color: row.state == 1 ? "red" : "",
                }}
              >
                {text}
              </span>
            );
          },
        },
        {
          title: "巡检目标",
          key: "facilityListName",
          minWidth: 150,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.facilityListName;
            return (
              <span
                style={{
                  color: row.state == 1 ? "red" : "",
                }}
              >
                {text}
              </span>
            );
          },
        },
        // {
        //   title: '场景',
        //   key: 'patrolScene',
        //   minWidth: 120,
        //   align: 'left',
        // },
        {
          title: "场景地址",
          key: "sceneSite",
          minWidth: 120,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.sceneSite;
            return (
              <span
                style={{
                  color: row.state == 1 ? "red" : "",
                }}
              >
                {text}
              </span>
            );
          },
        },
        {
          title: "巡检周期",
          key: "patrolInterval",
          minWidth: 120,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.timeUnit == 1
                ? row.patrolInterval + "分钟"
                : row.timeUnit == 2
                ? row.patrolInterval + "小时"
                : row.timeUnit == 3
                ? row.patrolInterval + "天"
                : row.timeUnit == 4
                ? row.patrolInterval + "周"
                : row.timeUnit == 5
                ? row.patrolInterval + "月"
                : row.timeUnit == 6
                ? row.patrolInterval + "季度"
                : row.timeUnit == 7
                ? row.patrolInterval + "年"
                : "";
            return (
              <span
                style={{
                  color: row.state == 1 ? "red" : "",
                }}
              >
                {text}
              </span>
            );
          },
        },
        // {
        //   title: '巡检开始时间',
        //   minWidth: 180,
        //   align: 'left',
        //   key: 'patrolBeginTime',
        // },
        {
          title: "巡检时间",
          width: 115,
          align: "center",
          key: "createTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.createTime.slice(0, 16);
            return <span>{text}</span>;
          },
        },
        {
          title: "操作",
          align: "center",
          width: 210,
          key: "handle",
          fixed: "right",
          handle: [
            // (vm, h, currentRow, param) => {
            //   let directives = [{ name: 'auth', value: '/admin/inspection/edit' }]
            //   return (
            //     <Button {...{ directives }} size="small" onClick={() => this.toAdd(currentRow)} type="text" style={{ margin: '0', color: '#66A2FF' }}>
            //       编辑
            //     </Button>
            //   )
            // },
            (vm, h, currentRow, param) => {
              // let directives = []
              let directives = [
                { name: "auth", value: "system/inspection/check" },
              ];
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.toCheck(currentRow)}
                  type="default"
                  style={{
                    border:"none",
                    color: "#4991ff",marginRight: "5px" }}
                >
                  巡检记录
                </Button>
              );
            },
            (vm, h, currentRow, param) => {
              // let directives = []
              let directives = [
                { name: "auth", value: "system/inspection/info" },
              ];
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.toinfo(currentRow)}
                  type="default"
                  style={{
                    border:"none",
                    color: "#4991ff",margin: "0"}}
                >
                  详情
                </Button>
              );
            },
          ],
        },
      ],
    };
  },
  created() {
  },
  methods: {
    toCheck(row) {
      this.$Modal.success({
        closable: true,
        title: "巡检记录",
        width: "1000px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <Check
              style={{ margin: "0", color: "#19be6b" }}
              planId={row.id}
            ></Check>
          );
        },
      });
    },
    //详情
    toinfo(row) {
      $utils.url.push({
        name: "inspection_info_weixiu",
        query: { action: "edit", kv: row.id, planId: row.id },
      });
    },
    // //导出
    // toImport() {},
    // //下载模板
    // toDownload() {},
  },
};
</script>
<style scoped></style>
